module.exports = __webpack_public_path__ + "static/media/career-news.b3e97897.jpg";